<ion-avatar style="margin: 5px 0" slot="start" *ngIf="thumbnailUrl$ | async as url">
  <img [src]="url" />
</ion-avatar>
